<template>
  <div class="but-wrapper">
    <vbutton
      class="but"
      :text="$tr('interview.tests.all.questions.button.end')"
      :disabled="!canSave || loading"
      :loading="loading"
      @click="save"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'AnswersSendBtn',

  data() {
    return {
      isSaving: false
    };
  },

  computed: {
    ...mapGetters('tests_test', {
      canSave: 'questions/canSave',
      loading: 'questions/loading'
    })
  },

  methods: {
    ...mapMutations('tests_test', { set_loading: 'questions/set_loading' }),

    save() {
      if (!this.isSaving) {
        this.isSaving = true;
        this.set_loading(true);
        // questionId = null отправляем потому, что показываем все вопросы на странице
        this.$store
          .dispatch('tests_test/questions/save', null)
          .then(async () => {
            await this.$emit('end');
            this.set_loading(false);
          })
          .finally(() => {
            this.isSaving = false;
            this.set_loading(false);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.but-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
